import nonStrict from 'fastdom';
// Uncomment to run fastdom in strict mode
// import strict from 'fastdom/fastdom-strict';

export const fastdom = nonStrict;
